import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  resetJuridiction,
  restPlantype,
  resetCodebook,
} from "@safecv/src/Actions/types";

import "./PlanReview.css";

class PlanReview extends Component {
  resetDropDownData = () => {
    const {
      jurisdictions,
      planTypes,
      codebooks,
      resetJuridiction,
      restPlantype,
      resetCodebook,
    } = this.props;
    jurisdictions.length > 0 && resetJuridiction();
    planTypes.length > 0 && restPlantype();
    codebooks.length > 0 && resetCodebook();
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="zero-padding col-6">
            <h1 className="textstyle1">Plan Reviews</h1>
          </div>
          <div className="addplan col-6">
            <Link to={{ pathname: "/addplans" }}>
              <button
                className="addplanbutton"
                onClick={() => this.resetDropDownData()}
              >
                Add Plan
              </button>
            </Link>
          </div>
          <hr className="line" />
        </div>
      </div>
    );
  }
}

const mapStatetoProps = (state) => ({
  jurisdictions: state.criteria.jurisdictions,
  planTypes: state.criteria.planTypes,
  codebooks: state.criteria.codebooks,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    resetJuridiction: () => {
      dispatch(resetJuridiction());
    },
    restPlantype: () => {
      dispatch(restPlantype());
    },
    resetCodebook: () => {
      dispatch(resetCodebook());
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(PlanReview);
